import { LocationVarKey } from '@swivl-mono/types';
import { PageHeader, TextAreaRow } from '../../../Components/Worksheets/WorksheetComponent/WorksheetComponents';
import { usePropertiesGetLocationIds } from '../../../Hooks/usePropertiesGetLocationIds';

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return <>
    <PageHeader {...page}
      subheading=""
    > Franchise</PageHeader>

    <TextAreaRow {...page}
      marginTop
      label=" Message 1"
      keyName={LocationVarKey.PurchaseFranchise1}
    />
    <TextAreaRow {...page}
      marginTop
      label=" Message 2 (Optional)"
      keyName={LocationVarKey.PurchaseFranchise2}
      enableSwitchVar={LocationVarKey.PurchaseFranchise2Enabled}
    />
  </>
}